import Vue from 'vue';
import Router from 'vue-router';
// import HelloWorld from '@/components/HelloWorld'
import Home from '@/pages/home/home';
import Jdwb from '@/pages/activity/jdwb';
import Jdsem from '@/pages/activity/jdsem';
import Jdlh from '@/pages/activity/jdlh';
import Loljch from '@/pages/activity/loljch';
import Khdxz from '@/pages/activity/khdxz';
import Wifisp from '@/pages/activity/wifi/wifisp';
import Wifiyx from '@/pages/activity/wifi/wifiyx';
import Forfree from '@/pages/activity/forfree/forfree';
import Assistance from '@/pages/activity/forfree/assistance';
import Rebate from '@/pages/activity/rebate/rebate';

import Publish from '@/pages/home/publish';
import Rank from '@/pages/home/rank';
import Wzry from '@/pages/game/wzry';
import Cyhx from '@/pages/game/cyhx';
import Dxcys from '@/pages/game/dxcys';
import Yxlm from '@/pages/game/yxlm';
import Yxlm2 from '@/pages/game/yxlm2';
import Yxlm3 from '@/pages/game/yxlm3';
import Result from '@/pages/game/result';
import Animation from '@/pages/game/animation';
import Test from '@/pages/game/test';
import ZfbRedPackage from '@/pages/activity/zfbActivity'


Vue.use(Router);

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/gz',
			name: 'home',
			component: Home
		},
		{
			path: '/jdwb',
			name: 'jdwb',
			component: Jdwb,
			meta: {
				title: '绝地求生1元试玩-高端游戏账号试玩平台-虚贝网'
			}
		},
		{
			path: '/rebate',
			name: 'rebate',
			component: Rebate,
			meta: {
				title: '下单返利'
			}
		},
		{
			path: '/jdsem',
			name: 'jdsem',
			component: Jdsem,
			meta: {
				title: '绝地求生1元试玩-高端游戏账号试玩平台-虚贝网'
			}
		},
		{
			path: '/jdlh',
			name: 'jdlh',
			component: Jdlh,
			meta: {
				title: '绝地求生1元试玩-高端游戏账号试玩平台-虚贝网'
			}
		},
		{
			path: '/loljch',
			name: 'loljch',
			component: Loljch,
			meta: {
				title: '英雄联盟绝版皮肤高端号试玩体验-百款热门游戏任你玩-虚贝网'
			}
		},
		{
			path: '/khdxz',
			name: 'khdxz',
			component: Khdxz,
			meta: {
				title: '虚贝租号客户端|租号上号器|游戏租号上号器下载-虚贝官方版'
			}
		},

		{
			path: '/wifisp',
			name: 'wifisp',
			component: Wifisp,
			meta: {
				title: '高端帐号免费试玩'
			}
		},
		{
			path: '/wifiyx',
			name: 'wifiyx',
			component: Wifiyx,
			meta: {
				title: '视频VIP帐号免费送'
			}
		},
		{
			path: '/forfree',
			name: 'forfree',
			component: Forfree,
			meta: {
				title: '好友助力顶尖帐号免费玩'
			}
		},

		{
			path: '/assistance',
			name: 'assistance',
			component: Assistance,
			meta: {
				title: '帮我点下助力，拜托了~ 助力就可以免费体验这个号啦！'
			}
		},

		// {
		//   path: '/gz',
		//   name: 'home',
		//   component: Home
		// },
		{
			path: '/publish',
			name: 'publish',
			component: Publish
		},
		{
			path: '/rank',
			name: 'rank',
			component: Rank
		},
		{
			path: '/wzry',
			name: 'wzry',
			component: Wzry
		},
		{
			path: '/cyhx',
			name: 'cyhx',
			component: Cyhx
		},
		{
			path: '/dxcys',
			name: 'dxcys',
			component: Dxcys
		},
		{
			path: '/yxlm',
			name: 'yxlm',
			component: Yxlm
		},
		{
			path: '/yxlm2',
			name: 'yxlm2',
			component: Yxlm2
		},
		{
			path: '/yxlm3',
			name: 'yxlm3',
			component: Yxlm3
		},
		{
			path: '/result',
			name: 'result',
			component: Result
		},
		{
			path: '/animation',
			name: 'animation',
			component: Animation
		},
		{
			path: '/test',
			name: 'test',
			component: Test
		},
		{
			path: '/benefits',
			component: resolve => require(['@/pages/app/Benefits.vue'], resolve),
			meta: {
				title: '新人福利'
			}
		},
		{
			path: '/happy_new_year',
			component: resolve => require(['@/pages/app/HappyNewYear.vue'], resolve),
			meta: {
				title: '你返程我买单'
			}
		},
		{
			path: '/one_dollar',
			component: resolve => require(['@/pages/app/OneDollar.vue'], resolve),
			meta: {
				title: '一元租号'
			}
		},
		{
			path: '/guangfa_credit_card',
			component: resolve => require(['@/pages/app/CreditCard.vue'], resolve),
			meta: {
				title: '广发信用卡'
			}
		},
		{
			path: '/apply_shared',
			component: resolve => require(['@/pages/app/ApplyShared.vue'], resolve),
			meta: {
				title: '申请合租'
			}
		},
		{
			path: '/shared_authentication',
			component: resolve => require(['@/pages/app/SharedAuthentication'], resolve),
			meta: {
				title: '合租商户认证'
			}
		},
		{
			path: '/downLoadXBApp',
			component: resolve => require(['@/pages/app/downLoadXBApp'], resolve),
			meta: {
				title: '下载虚贝APP'
			}
		},
		{
			path: '/downLoadXBlgj',
			component: resolve => require(['@/pages/app/downLoadXBlgj'], resolve),
			meta: {
				title: '下载虚贝租号APP'
			}
		},
		{
			path: '/rechargeActivity',
			component: resolve => require(['@/pages/app/RechargeActivity'], resolve),
			meta: {
				title: '蛇年新春送豪礼'
			}
		},

		{
			path: '/extendActivity',
			component: resolve => require(['@/pages/app/ExtendActivity'], resolve),
			meta: {
				title: '推广活动'
			}
		},
		{
			path: '/myPrize',
			component: resolve => require(['@/pages/app/MyPrize'], resolve),
			meta: {
				title: '我的奖品'
			}
		},
		{
			path: '/invitation',
			component: resolve => require(['@/pages/app/invitation'], resolve),
			meta: {
				title: '邀请好友'
			}
		},
		{
			path: '/wishing',
			component: resolve => require(['@/pages/app/Wishing'], resolve),
			meta: {
				title: '许愿池'
			}
		},
		{
			path: '/returnActivity',
			component: resolve => require(['@/pages/app/ReturnActivity'], resolve),
			meta: {
				title: '开通周卡退2元'
			}
		},
		{
			path: '/july-activity',
			component: resolve => require(['@/pages/app/july-active/july-activity'], resolve),
			meta: {
				title: '月度活动'
			}
		},
		{
			path: '/task-center',
			component: resolve => require(['@/pages/app/july-active/task-center'], resolve),
			meta: {
				title: '任务中心'
			}
		},
		{
			path: '/svip',
			component: resolve => require(['@/pages/app/svip'], resolve),
			meta: {
				title: '会员中心'
			}
		},
		{
			path: '/svipNew',
			component: resolve => require(['@/pages/app/newSvip'], resolve),
			meta: {
				title: '会员中心'
			}
		},
		{
			path: '/complaint',
			component: resolve => require(['@/pages/app/complaint.vue'], resolve),
			meta: {
				title: '投诉'
			}
		},
		{
			path: '/official-accounts-coupon',
			component: resolve => require(['@/pages/app/official-accounts-coupon'], resolve),
			meta: {
				title: '虚贝周末券专场'
			}
		},
		{
			path: '/svipProtocol',
			component: resolve => require(['@/pages/app/svipProtocol'], resolve),
			meta: {
				title: '会员服务协议'
			}
		},
		{
			path: '/bonus',
			component: resolve => require(['@/pages/app/weChat-bonus'], resolve),
			meta: {
				title: '专属福利官'
			}
		},
		{
			path: '/qiwei',
			component: resolve => require(['@/pages/activity/qiwei'], resolve),
			meta: {
				title: '虚贝福利官权益激活'
			}
		},
		{
			path: '/qiwei-coupon',
			component: resolve => require(['@/pages/activity/qiwei/qiwei-coupon'], resolve),
			meta: {
				title: '虚贝周末券专场'
			}
		},
		{
			path: '/pangguai',
			component: resolve => require(['@/pages/activity/pangguai/index'], resolve),
			meta: {
				title: '胖乖生活&虚贝租号'
			}
		},
		{
			path: '/tuiguang',
			component: resolve => require(['@/pages/activity/tuiguang/index'], resolve),
			meta: {
				title: '推广'
			}
		},
		{
			path: '/fanswelfare',
			component: resolve => require(['@/pages/activity/fanswelfare/index'], resolve),
			meta: {
				title: '粉丝专享福利领取'
			}
		},
		{
			path: '/tuiguang-faq',
			component: resolve => require(['@/pages/activity/tuiguang/tuiguangfaq'], resolve),
			meta: {
				title: '推广FAQ'
			}
		},
		{
			path: '/choujiang',
			component: resolve => require(['@/pages/activity/tuiguang/choujiang'], resolve),
			meta: {
				title: '首充'
			}
		},
		{
			path: '/delta-force-group',
			component: resolve => require(['@/pages/activity/deltaForceGroup/index'], resolve),
			meta: {
				title: '虚贝三角洲官方服务群'
			}
		},
		{
			path: '/qiwei-tuiguang',
			component: resolve => require(['@/pages/activity/qiwei/tuiguang'], resolve),
			meta: {
				title: '虚贝官方群'
			}
		},
		{
			path: '/thali',
			component: resolve => require(['@/pages/app/thali.vue'], resolve),
			meta: {
				title: '套餐说明'
			}
		},
		{
			path: '/shanghu-level',
			component: resolve => require(['@/pages/activity/shanghulevel'], resolve),
			meta: {
				title: '商户等级'
			}
		},
		{
			path: '/shanghu-introduce',
			component: resolve => require(['@/pages/activity/shIntroduce'], resolve),
			meta: {
				title: '虚贝商户-让爱好成为事业'
			}
		},
		// {
		// 	path: '/publish-product',
		// 	component: resolve => require(['@/pages/app/publishProduct'], resolve),
		// 	meta: {
		// 		title: '发布商品'
		// 	}
		// },
		{
			path: '/xy-activity',
			component: resolve => require(['@/pages/xianyu/activity'], resolve),
			meta: {
				title: '闲鱼活动'
            }
        },
		{
			path: '/publish-product',
			component: resolve => require(['@/pages/app/publishProduct'], resolve),
			meta: {
				title: '发布商品'
			}
		},
		{
			path: '/assistance-time',
			component: resolve => require(['@/pages/activity/assistanceTime'], resolve),
			meta: {
				title: '邀请助力'
			}
		},	
		{
			path: '/add-wxcompony',
			component: resolve => require(['@/pages/app/addWxCompony'], resolve),
			meta: {
				title: '加福利官抽99，保底必得红包'

			}
		},
		{
			path: '/zfb-redpackage',
			component: resolve => require(['@/pages/activity/zfbActivity'], resolve),
			meta: {
				title: '支付宝租号补贴'
			}
		}
	]
});



// WEBPACK FOOTER //
// ./src/router/index.js